(function () {
  "use strict";

  CatalogResolver.$inject = ['$q', '$route', 'catalogResource', 'groupsResource', 'Validation', 'errorHandler', 'refreshSession', 'Auth'];
  angular
    .module('trainerWebApp.resources')
    .factory('CatalogResolver', CatalogResolver);

  function CatalogResolver($q, $route, catalogResource, groupsResource, Validation, errorHandler, refreshSession, Auth) {

    function normalizeTypes(items) {
      if (!items || items.length === 0) return [];
      for (var i = 0, c = items.length; i < c; i++) {
        items[i].type = items[i].type === 'Online' ? 'Course' : 'Series';
      }
      return items;
    }

    function normalizeGroups(groups) {
      return _.sortBy(_.map(groups, function (group) {
        return {id: group.id, text: group.name};
      }), 'text');
    }

    function addSeriesThumbUrls(items) {
      if (!items || items.length === 0) return [];
      for (var i = 0, c = items.length; i < c; i++) {
        if (items[i].type === 'Series') {
          items[i].smallThumbUrl = 'images/home/tn_series.png';
          items[i].thumbUrl = 'images/home/tn_series.png';
        }
      }
      return items;
    }

    return function () {
      var deferred = $q.defer();
      var mainDeferred = $q.defer();
      var groupsDeferred = $q.defer();
      var pageName = $route.current.params.pageName || $route.current.pageName;
      var catalogId = $route.current.params.catalogId;

      var successCb = function (result) {
        Auth.getRolePromise().then(function () {
          mainDeferred.resolve(result);
        });
      };

      if (!Validation.validate()) {
        deferred.reject(false);
        return deferred.promise;
      }

      if (!pageName || pageName == 'catalog') {
        refreshSession.refresh(null, function () {
          catalogResource.load(catalogId, function (catalog) {
            catalog.items = normalizeTypes(catalog.items);
            catalog.groups = normalizeGroups(catalog.groups);
            successCb(catalog);
          }, errorHandler.defaultServerErrorHandler());
        });

        groupsResource.getGroups(function (result) {
          groupsDeferred.resolve(result);
        }, errorHandler.defaultServerErrorHandler());

        $q.all([mainDeferred.promise, groupsDeferred.promise]).then(function (values) {
          return deferred.resolve({
            catalog: values[0],
            groups: values[1]
          });
        });
      } else if (pageName == 'addContentToCatalog') {
        deferred = mainDeferred;
        refreshSession.refresh(null, function () {
          catalogResource.getAddCoursesSetup(catalogId, function (addContentSetup) {
            addContentSetup.availableItems = addSeriesThumbUrls(normalizeTypes(addContentSetup.availableItems));
            successCb(addContentSetup);
          }, errorHandler.defaultServerErrorHandler());
        });
      }

      return deferred.promise;
    };
  }

})();
